export const featuredPortfolio = [
  {
    id: 1,
    title: "DigitalDavis",
    link: "https://github.com/Final-Iteration/DigitalDavis",
    img: "./assets/UCD_10.png",
  },
  {
    id: 2,
    title: "USGS Project CoastSeg",
    link: "https://github.com/dbuscombe-usgs/CoastSeg",
    img: "./assets/coastseg4.gif",
  },
];
//   {
//     id: 3,
//     title: "E-commerce Web Design",
//     link: "https://github.com/Final-Iteration/DigitalDavis",
//     img: "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
//   },
//   {
//     id: 4,
//     title: "Relax Mobile App",
//     link: "https://github.com/Final-Iteration/DigitalDavis",
//     img: "https://cdn.dribbble.com/users/4095861/screenshots/15467417/media/d6a15c416626f12b31fa5ca1db192572.png?compress=1&resize=1200x900",
//   },
//   {
//     id: 5,
//     title: "Hero Web Design",
//     link: "https://github.com/Final-Iteration/DigitalDavis",
//     img: "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
//   },
//   {
//     id: 6,
//     title: "Banking App",
//     link: "https://github.com/Final-Iteration/DigitalDavis",
//     img: "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
//   },
// ];

export const WebDev_Portfolio = [
  {
    id: 1,
    title: "React Native",
    img: "https://www.futuremind.com/m/articles/none/react_native_vs_native_apps.png",
  },
  {
    id: 2,
    title: "Docker",
    img: "./assets/docker.png",
  },
  {
    id: 3,
    title: "Node",
    img: "./assets/node.png",
  },
  {
    id: 4,
    title: "C++",
    img: "./assets/c++2.png",
  },
  {
    id: 5,
    title: "Java",
    img: "./assets/java2.jpg",
  },
];

export const DataPortfolio = [
  {
    id: 1,
    title: "Python",
    img: "./assets/Python.png",
  },
  {
    id: 2,
    title: "SQL",
    img: "./assets/sql.jpg",
  },
  {
    id: 3,
    title: "MongoDB",
    img: "./assets/mongo-db.png",
  },
  {
    id: 4,
    title: "MatplotLib",
    img: "./assets/matplotlib_data.png",
  },
  {
    id: 5,
    title: "Pandas",
    img: "./assets/pandas.png",
  },
];
